// extracted by mini-css-extract-plugin
export default {"wrapper":"ActiveFilterButton_wrapper__Mlle7","dark":"ActiveFilterButton_dark__WaQqC"};